<template>
    <div class="page-table scrollable only-y mainDiv">
        <div class="card-base baslikBg animated fadeInUp">{{$t("src.views.apps.urun.kategori.liste.baslikH1")}}</div>
        <div class="page-header card-base card-shadow--medium animated fadeInUp">
            <el-table
                    :data="kategoriList"
                    style="width: 100%">
                <el-table-column
                        label="Sıra"
                        type="index">
                </el-table-column>
                <el-table-column
                        sortable
                        prop="baslik"
                        label="Başlık"
                        width="auto">
                </el-table-column>
                <el-table-column
                        label="İşlem"
                        align="right"
                        width="auto">
                    <template slot-scope="scope">
                        <el-tooltip :content='$t("src.views.apps.urun.liste.urunduzenle")'
                                    :open-delay="500"
                                    placement="bottom">
                            <el-button
                                    v-if="root || yetkiList.urunKategoriGuncelle"
                                    v-on:click="routeUrun('Kategori Düzenle',scope.row)"
                                    type="text"
                                    class="buttonEdit"
                                    icon="el-icon-edit">
                            </el-button>
                        </el-tooltip>
                        <el-tooltip :content='$t("src.views.apps.urun.liste.yayindanKaldir")' :open-delay="500"
                                    placement="bottom">
                            <el-button
                                    class="buttonDel"
                                    type="text"
                                    @click="deleteDialogVisible = true; selection = scope.row; selectionIndex = scope.$index"
                                    icon="mdi mdi-pause mdi-24px">
                            </el-button>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-dialog
                :title='$t("src.views.apps.urun.liste.uyari")'
                :visible.sync="deleteDialogVisible"
                width="30%"
                center>
            <span>'{{selection.baslik}}' {{$t('src.views.apps.urun.liste.uruntaslak')}}</span>
            <span slot="footer" class="dialog-footer">
                    <el-button icon="el-icon-check"
                               type="success"
                               size="mini"
                               @click="kategoriKaldir(selection,selectionIndex,kategoriList), deleteDialogVisible = false"></el-button>
                    <el-button type="danger" size="mini" icon="el-icon-close"
                               @click="deleteDialogVisible = false"></el-button>
                </span>
        </el-dialog>
    </div>

</template>

<script>
    import urunService from '../../../../WSProvider/UrunService'
    import notification from '../../../../notification'

    let base64 = require('base64_js');
    let userDataEstas = "";

    export default {
        name: "Kategoriistesi",
        data() {
            return {
                pathh: urunService.path,
                kategoriList: [],
                urunlarListTaslak: [],
                deleteDialogVisible: false,
                taslakDialogVisible: false,
                selection: '',
                selectionIndex: '',
                root : false,
                yetkiList: {
                    urunKategoriGuncelle: false,
                    urunKategoriDurumDegis: false,
                },
            }
        },
        mounted() {
            let self = this;
            if (localStorage.getItem("userDataEstas")) {
                userDataEstas = JSON.parse(base64.decode(localStorage.getItem("userDataEstas")));
                if (userDataEstas["tur"]) {
                    if (userDataEstas["tur"] === '1') {
                        self.root = true;
                        self.yetkiList.urunKategoriDurumDegis = true;
                        self.yetkiList.urunKategoriGuncelle = true;
                    }
                }
                if (userDataEstas["yetki"]) {
                    userDataEstas["yetki"].forEach(function (value) {
                        switch (value.yetkiKodu) {
                            case 'YK-482800':
                                self.yetkiList.urunKategoriGuncelle = true;
                                self.yetkiList.urunKategoriDurumDegis = true;
                                break;
                            case 'YK-462516':
                                self.yetkiList.urunKategoriDurumDegis = true;
                                break;
                        }
                    });
                }

            }

            this.getOpsiyonList();

        },
        methods: {
            routeUrun(name, scope) {
                var tabList = this.$store.state.tabList;
                if (scope) {
                    this.$store.commit('changeUpdateKodu', scope.ukategoriKodu);
                }
                var header = linkTemizle(name.replace(" ", ""));
                var obj = tabList.find(data => data.title === name);
                if (obj === undefined) {
                    tabList.push({
                        title: name,
                        name: header,
                        contentName: header
                    });
                    this.$store.commit('changeTabList', tabList);
                    this.$store.commit('changeActiveTabs', header);
                } else {
                    this.$store.commit('changeActiveTabs', header);
                }
            },
            getOpsiyonList() {
                let self = this;
                urunService.kategoriList().then((response) => {
                    if (response.status === 200) {
                        // response.data.forEach(function (e) {
                        //     if(e.durum === '1'){
                        //         self.kategoriList.push(e);
                        //
                        //     }
                        //
                        // })
                        self.kategoriList= response.data;
                    }
                })
            },
            kategoriKaldir(selection, index, list) {
                urunService.kategoriKaldir(selection.ukategoriKodu).then((response) => {
                    if (response.status === 200) {
                        list.splice(index, 1);
                        notification.Status('success', this, "Kategori başarıyla kaldırıldı.")
                    } else {
                        notification.Status(response.status, this)
                    }
                })
            },
        }
    }

    function linkTemizle(text) {
        var trMap = {
            'çÇ': 'c',
            'ğĞ': 'g',
            'şŞ': 's',
            'üÜ': 'u',
            'ıİ': 'i',
            'öÖ': 'o'
        };
        for (var key in trMap) {
            text = text.replace(new RegExp('[' + key + ']', 'g'), trMap[key]);
        }
        return text.replace(/[^-a-zA-Z0-9\s]+/ig, '')
            .replace(/\s/gi, "-")
            .replace(/[-]+/gi, "-")

    }
</script>

<style lang="scss" scoped>
    .el-pagination {
        margin-top: 20px;
        float: right;
    }

    .kaldirilmis {
        background: #ec205f;
        color: white;
        font-weight: bold;
        font-size: 16px;
        padding: 10px
    }
</style>